import { useEffect, useRef } from "react";
import { MuiMaterials } from "../@index.js";
import { useAuth } from "../provider/authProvider";
import { Spinner } from "./windowChrome/index.js";

const Logout = () => {
    const { clearToken } = useAuth();
    const started = useRef(false);

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        clearToken();
        window.location.replace("/emailLogin");
    }, [clearToken]);

    return (
        <MuiMaterials.Box
            sx={{
                minHeight: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Spinner size="page" />
        </MuiMaterials.Box>
    );
};

export default Logout;